<div>
  <Navbar />
  <Sidebar />

  <div class="page-wrapper">
    <div class="hero-section w-100">
      <div class="border rounded-4 p-2 custom-border">

        <!-- Page Header -->
        <div class="page-header mb-4">
          <h2 class="fw-bold mb-1">Connect Accounts</h2>
          <p class="text-muted mb-0">Manage your connected services and integrations</p>
        </div>

        <!-- Secondary Navigation Pills (Sub-sections within this page) -->
        <div class="sub-navigation mb-4 d-none">
          <ul class="nav nav-pills settings-pills">
            <li class="nav-item">
              <a class="nav-link" href="#">Overview</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#">Sign in method</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#">Basic Information</a>
            </li>
            <li class="nav-item">
              <a class="nav-link active" href="#">Connected accounts</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#">Notifications</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#">Deactivate account</a>
            </li>
          </ul>
        </div>

        <!-- Main Content Area -->
        <div class="settings-content">

          <!-- Connected Accounts Section -->
          <div class="content-card mb-4">
            <!-- Security Banner -->
            <div class="alert alert-info border-0 d-flex align-items-start gap-3 mb-4 rounded-3">
              <div class="alert-icon">
                <i class="fa-solid fa-shield-halved"></i>
              </div>
              <div class="flex-grow-1">
                <div class="fw-semibold mb-1">Secure Your Account</div>
                <small class="text-muted d-block">Two-factor authentication adds an extra layer of security to your account.</small>
              </div>
              <a href="#" class="btn btn-sm btn-outline-primary text-nowrap d-none">Learn more</a>
            </div>

            <!-- Connected Apps List -->
            <div class="connected-apps-list">
              <div class="account-row" v-for="acc in accounts" :key="acc.key">
                <div class="d-flex align-items-center gap-3 flex-grow-1">
                  <div class="app-icon-wrap d-flex align-items-center justify-content-center rounded-3 shadow-sm">
                    <img :src="acc.icon" alt="" />
                  </div>
                  <div class="flex-grow-1">
                    <div class="fw-semibold mb-1">{{ acc.name }}</div>
                    <small class="text-muted">{{ acc.subtitle }}</small>
                  </div>
                </div>

                <div class="form-check form-switch d-none">
                  <input class="form-check-input" type="checkbox" role="switch"
                         :id="`sw-${acc.key}`" v-model="acc.enabled" />
                  <label class="form-check-label small text-muted ms-2" :for="`sw-${acc.key}`">
                    {{ acc.enabled ? 'Enabled' : 'Disabled' }}
                  </label>
                </div>
              </div>
            </div>

            <!-- Action Buttons -->
            <div class="card-footer-custom border-top pt-3 mt-4 d-none">
              <div class="d-flex justify-content-end gap-2">
                <button class="btn upload-button btn-sm box-shadow small d-flex align-items-center" @click="discardChanges" :disabled="saving">Discard</button>
                <button class="upload-button btn-sm text-white box-shadow small d-flex align-items-center" @click="saveChanges" :disabled="saving">
                  <span v-if="saving" class="spinner-border spinner-border-sm me-2"></span>
                  Save changes
                </button>
              </div>
            </div>
          </div>

          <!-- Notifications Section -->
          <div class="content-card">
            <div class="card-header-custom border-bottom pb-3 mb-4">
              <h5 class="mb-1 fw-semibold">Email Notifications</h5>
              <small class="text-muted">Choose how often you receive email notifications</small>
            </div>

            <div class="list-group list-group-flush rounded-3 border">
              <label class="list-group-item d-flex align-items-center gap-3 cursor-pointer">
                <input class="form-check-input flex-shrink-0" type="radio" value="immediate" v-model="notifFrequency" />
                <div>
                  <div class="fw-semibold small">Send me email notifications</div>
                  <small class="text-muted">Get notified immediately for all activities</small>
                </div>
              </label>
              <label class="list-group-item d-flex align-items-center gap-3 cursor-pointer">
                <input class="form-check-input flex-shrink-0" type="radio" value="hourly" v-model="notifFrequency" />
                <div>
                  <div class="fw-semibold small">Once an hour at most</div>
                  <small class="text-muted">Receive a digest of notifications every hour</small>
                </div>
              </label>
              <label class="list-group-item d-flex align-items-center gap-3 cursor-pointer">
                <input class="form-check-input flex-shrink-0" type="radio" value="never" v-model="notifFrequency" />
                <div>
                  <div class="fw-semibold small">Never</div>
                  <small class="text-muted">Don't send me any email notifications</small>
                </div>
              </label>
            </div>

            <!-- Action Buttons -->
            <div class="card-footer-custom border-top pt-3 mt-4 d-none">
              <div class="d-flex justify-content-end gap-2">
                <button class="btn upload-button btn-sm box-shadow small d-flex align-items-center" @click="resetNotifications" :disabled="savingNotif">Discard</button>
                  <button class="upload-button btn-sm text-white box-shadow small d-flex align-items-center" @click="saveNotifications" :disabled="savingNotif">
                    <span v-if="savingNotif" class="spinner-border spinner-border-sm me-2"></span>
                    Save changes
                  </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<PoweredBy/>
